import { FeatureFlags } from 'utils/featureFlags';
import useFeatureFlag from './useFeatureFlag';

export function useCrmPricingEmbedFlag(): boolean {
  const flags = useFeatureFlag([FeatureFlags.crmPricingEmbed]);
  return flags[FeatureFlags.crmPricingEmbed] === true;
}
